import { faCreditCard } from "@fortawesome/pro-duotone-svg-icons/faCreditCard";

import { type Breadcrumb } from "@application/types/breadcrumb";

export const DASHBOARD_BILLING_LINK: Breadcrumb = {
  icon: faCreditCard,
  name: "Billing",
  to: "/dashboard/billing",
};
